// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
interface Props {
  onClick?: (e?: React.MouseEvent<SVGElement>) => void;
  style?: React.CSSProperties;
  color?: string;
}
export const IconDropDown: React.FC<Props> = ({ onClick, style, color }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={style}
    >
      <path
        d="M1 1L4.85858 4.85858C4.93668 4.93668 5.06332 4.93668 5.14142 4.85858L9 1"
        stroke={color ?? '#9EA0A2'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
